import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckboxInput, Password, Select, TextArea, TextInput, } from '@guildeducationinc/recess';
import { DatePicker } from '../DatePicker';
// import { FileUpload } from '../FileUpload';
import { HtmlEditor } from '../HtmlEditor';
import { TimePicker } from '../TimePicker';
import styles from './FormFieldInput.module.scss';
const HelpTextBox = ({ children }) => (_jsx("div", { className: styles.helpTextBox, children: children }));
const getHelpTextProps = (helpText) => {
    const helpTextStr = typeof helpText === 'string' ? helpText : undefined;
    const helpTextNode = helpText && !helpTextStr ? _jsx(HelpTextBox, { children: helpText }) : null;
    return { helpTextStr, helpTextNode };
};
export const FormFieldInput = ({ fieldInfo, value, errors, onChange, disabled, }) => {
    const { label, type } = fieldInfo;
    const isNumber = type === 'number';
    const isBool = type === 'boolean';
    const isDate = type === 'date';
    const isTime = type === 'time';
    const isTimeZone = type === 'timezone';
    const isLookup = type === 'lookup';
    const isTextArea = type === 'textarea';
    const isPassword = type === 'password';
    // const isUpload = type === 'upload';
    const handleChange = (e) => {
        if (isBool) {
            onChange(e.target.checked.toString());
        }
        else {
            onChange(e.target.value);
        }
    };
    const handleDateChange = (value) => {
        onChange(value || '');
    };
    const handleSelectChange = (e) => {
        onChange(e.target.value || '');
    };
    const handleRichTextChange = (content) => {
        onChange(content);
    };
    // const handleUpload = (s3Key: string) => {
    //   onChange(s3Key);
    // };
    const handleTextAreaChange = (e) => {
        onChange(e.currentTarget.value);
    };
    const handleTimeChange = (value) => {
        onChange(value);
    };
    if (isBool) {
        return (_jsxs(_Fragment, { children: [_jsx(CheckboxInput, { label: label, checked: (value || 'false').toString().toLowerCase() === 'true', onChange: handleChange, errors: errors, additionalInfo: fieldInfo.infoText, className: fieldInfo.className, disabled: disabled ?? fieldInfo.disabled }), fieldInfo.helpText && _jsx(HelpTextBox, { children: fieldInfo.helpText })] }));
    }
    if (isDate) {
        const { helpTextStr, helpTextNode } = getHelpTextProps(fieldInfo.helpText);
        return (_jsxs(_Fragment, { children: [_jsx(DatePicker, { label: label, value: value, onChange: handleDateChange, errors: errors, additionalInfo: fieldInfo.infoText, disabled: disabled ?? fieldInfo.disabled, helpText: helpTextStr }), helpTextNode] }));
    }
    if (isLookup) {
        const options = [];
        const fieldOptions = fieldInfo.options;
        if (Array.isArray(fieldOptions)) {
            fieldOptions.forEach(opt => {
                if (typeof opt === 'string') {
                    options.push({ value: opt, label: opt });
                }
                else {
                    options.push(opt);
                }
            });
        }
        const { helpTextStr, helpTextNode } = getHelpTextProps(fieldInfo.helpText);
        return (_jsxs(_Fragment, { children: [_jsx(Select, { easyPortal: true, label: label, value: fieldInfo.multiple ? (value || '').toString().split(',') : value.toString(), options: options, onChange: handleSelectChange, errors: errors, additionalInfo: fieldInfo.infoText, className: fieldInfo.className, disabled: disabled ?? fieldInfo.disabled, helpText: helpTextStr, multiple: fieldInfo.multiple }), helpTextNode] }));
    }
    if (isTextArea) {
        const { helpTextStr, helpTextNode } = getHelpTextProps(fieldInfo.helpText);
        if (fieldInfo.plainText) {
            return (_jsxs(_Fragment, { children: [_jsx(TextArea, { rev: '', label: label, value: value || '', onChange: handleTextAreaChange, errors: errors, additionalInfo: fieldInfo.infoText, className: fieldInfo.className, disabled: disabled ?? fieldInfo.disabled, helpText: helpTextStr, autosize: fieldInfo.autosize, fullWidth: true }), helpTextNode] }));
        }
        else {
            return (_jsxs(_Fragment, { children: [_jsx(HtmlEditor, { label: label, value: value || '', onChange: handleRichTextChange, errors: errors, additionalInfo: fieldInfo.infoText, disabled: disabled ?? fieldInfo.disabled, helpText: helpTextStr }), helpTextNode] }));
        }
    }
    // if (isUpload) {
    //   return (
    //     <FileUpload
    //       label={label}
    //       s3Key={value || ''}
    //       s3KeyPrefix='images'
    //       errors={errors}
    //       fileType={fieldInfo.fileType}
    //       onUploaded={handleUpload}
    //       additionalInfo={fieldInfo.infoText}
    //       helpText={fieldInfo.helpText}
    //       disabled={disabled ?? fieldInfo.disabled}
    //     />
    //   );
    // }
    if (isTime) {
        return (_jsx(TimePicker, { label: label, value: value || '', onChange: handleTimeChange, errors: errors, additionalInfo: fieldInfo.infoText, disabled: disabled ?? fieldInfo.disabled }));
    }
    if (isTimeZone) {
        const options = [
            { value: 'ET', label: 'Eastern Time' },
            { value: 'CT', label: 'Central Time' },
            { value: 'MT', label: 'Mountain Time' },
            { value: 'PT', label: 'Pacific Time' },
            { value: 'HT', label: 'Hawaii Time' },
        ];
        return (_jsx(Select, { label: label, value: value.toString(), options: options, onChange: handleSelectChange, errors: errors, additionalInfo: fieldInfo.infoText, className: fieldInfo.className, disabled: disabled ?? fieldInfo.disabled }));
    }
    if (isPassword) {
        const { helpTextStr, helpTextNode } = getHelpTextProps(fieldInfo.helpText);
        return (_jsxs(_Fragment, { children: [_jsx(Password, { label: label, value: value || '', onChange: handleChange, errors: errors, additionalInfo: fieldInfo.infoText, disabled: disabled ?? fieldInfo.disabled, helpText: helpTextStr }), helpTextNode] }));
    }
    if (isNumber) {
        // Currently, the component returns the same 'TextInput' type for both cases (number and text).
        // The implementation ensures consistent behavior while allowing future updates to differentiate
        // handling based on the 'isNumber' condition, if necessary.
        const { helpTextStr, helpTextNode } = getHelpTextProps(fieldInfo.helpText);
        return (_jsxs(_Fragment, { children: [_jsx(TextInput, { label: label, type: 'text', value: value || '', onChange: handleChange, errors: errors, additionalInfo: fieldInfo.infoText || fieldInfo.additionalInfo, disabled: disabled ?? fieldInfo.disabled, helpText: helpTextStr }), helpTextNode] }));
    }
    const { helpTextStr, helpTextNode } = getHelpTextProps(fieldInfo.helpText);
    return (_jsxs(_Fragment, { children: [_jsx(TextInput, { label: label, type: 'text', value: value || '', onChange: handleChange, errors: errors, additionalInfo: fieldInfo.infoText || fieldInfo.additionalInfo, disabled: disabled ?? fieldInfo.disabled, helpText: helpTextStr }), helpTextNode] }));
};
